import { SidebarModule } from '@/config/permissions'
import { useAuthStore } from '@/stores/auth.store'
import { usePermissionsStore } from '@/stores/permissions.store'
import { useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

export function useModuleAccess(module: SidebarModule) {
  const navigate = useNavigate()
  const canViewModule = usePermissionsStore((state) => state.canViewModule)
  const isLoading = usePermissionsStore((state) => state.isLoading)
  const getHasFullTeamAccess = useAuthStore(
    (state) => state.getHasFullTeamAccess
  )
  const hasFullTeamAccess = getHasFullTeamAccess()

  useEffect(() => {
    if (isLoading || hasFullTeamAccess) {
      return
    }

    if (!canViewModule(module)) {
      navigate({ to: '/' })
    }
  }, [module, canViewModule, hasFullTeamAccess, isLoading, navigate])

  return {
    hasAccess: hasFullTeamAccess || canViewModule(module),
    isLoading,
  }
}
